<template>
  <div>
    <b-row class="justify-content-start">
      <b-col md="2" class="w-100" v-if="type == 'BULK'">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-col>
    </b-row>
    <b-row class="mb-3 justify-content-start">
      <!-- Left section filtre -->
      <b-col v-if="!flagBPCE && !flagTOOLBOX" cols="12" lg="8" xl="6" class="mt-2 text-xl-start">
        <b-button-group class="mt-3 mt-sm-0" style="display:grid;grid-auto-flow:column;" v-if="type !== 'BULK'">
          <b-button :variant="filters.tabName === 1 ? 'primary btn-selected' : ''" @click="changeTabName(1)">{{ $t('tracking.DDV') }}</b-button>
          <b-button v-if="flagCACP" :variant="filters.tabName === 2 ? 'primary btn-selected' : ''" @click="changeTabName(2)">{{ $t('tracking.DDD') }}</b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="TracksList.length > 0" style="overflow:auto">
      <b-table hover
        class="table table-striped"
        style="margin-bottom:0"
        :fields="fields"
        :items="TracksList"
        :selectable="TracksList.length > 0"
        :empty-text="$t('common.security.no_result')"
        @row-clicked="handleRowClicked"
        role="table"
        aria-label="Liste des transactions de suivi"
        sticky-header
        thead-class="text-center"
        tbody-class="text-center">
        <template #cell(CreationDateRq1)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(CreationDateRq1)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(Request2CreationDate)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(Response2CreationDate)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(CreationDateRp2)="data">
          <span>{{ getDate(data.item.Response2CreationDate) }}</span>
        </template>
        <template #cell(NameScore)="data">
          <span>{{ getResultText(data.value) }}</span>
        </template>
        <template #cell(BICFrom)="data">
          <span>{{ data.value }}</span>
        </template>
        <template #cell(TestCaseStatus)="data">
          <span>{{ getTestCaseStatus(data.value) }}</span>
        </template>
        <template #cell(BICOnUs)="data">
          <span v-if="data.value">
              <i v-if="data.value == 1" class="fa-regular fa-circle-check cursor color-var-actionButtonColorBlue" :aria-label="$t('common.success')" role="img"></i>
              <i v-if="data.value == 2" class="fa-regular fa-circle-xmark cursor text-danger" :aria-label="$t('common.error')" role="img"></i>
          </span>
          <span v-else> - </span>
        </template>
        <template #cell(BICTo)="data">
          <span>{{ data.value }}</span>
        </template>
        <template #cell(Country)="data">
          <span>{{ getCountry(data.item.CountryCode) }}</span>
        </template>
        <template #cell(IBAN)="data">
          <span>{{ data.value }}</span>
        </template>
        <template #cell(Status)="data">
          <span>{{ data.value }}</span>
        </template>
        <template #cell(Name)="data">
          <span v-if="data.item.FullName !== ''">{{ data.item.FullName }}</span>
          <span v-else> - </span>
        </template>
        <template v-if="tabName === 2 && !flagBPCE" #cell(Type)="data">
          <i v-if="data.item.Type === '2'" class="fa-solid fa-building" :aria-label="$t('common.company')" role="img"></i>
          <i v-else-if="data.item.Type === '1'" class="fa-solid fa-user" :aria-label="$t('common.individual')" role="img"></i>
          <span v-else> - </span>
        </template>
        <template #cell(TestedData)="data">
          <span v-if="data.item.FullName !== ''">{{ data.item.FullName }}</span>
          <span v-else-if="data.item.Siren !== ''">{{ data.item.Siren }}</span>
          <span v-else-if="data.item.Siret !== ''">{{ data.item.Siret }}</span>
          <span v-else-if="data.item.TVAIntracomm !== ''">{{ data.item.TVAIntracomm }}</span>
          <span v-else-if="data.item.LEI !== ''">{{ data.item.LEI }}</span>
          <span v-else-if="data.item.EUID !== ''">{{ data.item.EUID }}</span>
          <span v-else> - </span>
        </template>
        <template #cell(Result)="data">
          <span v-if="data.item.IdScore !== ''">
            <span
              class="result-vignette"
              :class="{
                'result-mtch': data.item.IdScore === 'MTCH',
                'result-nmtc': data.item.IdScore === 'NMTC',
                'result-cmtc': data.item.IdScore === 'CMTC',
                'result-noap': data.item.IdScore === 'NOAP',
              }"
            ></span>
            {{ getResultText(data.item.IdScore) }}
          </span>
          <span v-else-if="data.item.NameScore !== ''">
            <span
              class="result-vignette"
              :class="{
                'result-mtch': data.item.NameScore === 'MTCH',
                'result-nmtc': data.item.NameScore === 'NMTC',
                'result-cmtc': data.item.NameScore === 'CMTC',
                'result-noap': data.item.NameScore === 'NOAP',
              }"
            ></span>
            {{ getResultText(data.item.NameScore) }}
          </span>
          <span v-else> - </span>
        </template>
        <template #cell(TechStatusCode)="data">
          <span v-if="data.item.TechStatusCode !== ''">{{ translateTechStatusCode(data.item.TechStatusCode) }}</span>
          <span v-else>{{ $t('common.monitoring.success') }} </span>
        </template>
        <template #cell(Provider)="data">
          <span>{{ data.value == 1 ? 'STET':'EBA' }}</span>
        </template>
        <template #cell(ResponseDuration)="data">
          <span>{{ getDuration(data.item) }}</span>
        </template>
        <template v-if="flagCACP" #cell(ResultEntity)="data">
          <span v-if="data.item.IdScore2 !== ''">
            <span
              class="result-vignette"
              :class="{
                'result-mtch': data.item.IdScore2 === 'MTCH',
                'result-nmtc': data.item.IdScore2 === 'NMTC',
                'result-cmtc': data.item.IdScore2 === 'CMTC',
                'result-noap': data.item.IdScore2 === 'NOAP',
              }"
            ></span>
            {{ getResultText(data.item.IdScore2) }}
          </span>
          <span v-else-if="data.item.NameScore2 !== ''">
            <span
              class="result-vignette"
              :class="{
                'result-mtch': data.item.NameScore2 === 'MTCH',
                'result-nmtc': data.item.NameScore2 === 'NMTC',
                'result-cmtc': data.item.NameScore2 === 'CMTC',
                'result-noap': data.item.NameScore2 === 'NOAP',
              }"
            ></span>
            {{ getResultText(data.item.NameScore2) }}
          </span>
          <span v-else> - </span>
        </template>
        <template v-if="flagCACP" #cell(ReasonCodeAll)="data">
          <!-- <span v-if="data.item.ReasonCode">
            {{ $t('tracking.flagCACP.reason_code_optional_list.' + data.item.ReasonCode) }}
          </span> -->
          <span v-if="data.item.ReasonCodeEntity">
            {{ $t('tracking.flagCACP.reason_code_optional_entity_list.' + data.item.ReasonCodeEntity) }}
          </span>
          <span v-else>-</span>
        </template>
        <template #cell()="data">
          <span>{{ data.value ? data.value : '-' }}</span>
        </template>
        <template #cell(Result)="data">
          <span>{{ getResultDDD(data.item) }}</span>
        </template>
      </b-table>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult" v-if="flagCACP && (tabName === 1 || tabName === 2)">
          {{ isMandatoryFieldMiss ? $t('common.missing_required_field') : $t('common.no_result') }}
      </span>
      <span class="noResult" v-else>
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5">
      <b-col cols="12">
        <cm-pagination v-if="!flagCACP"
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>

        <cm-pagination-tracking-cacp v-else
            :maxResultsByPage="paginationObject.maxResults"
            :firstIndex="paginationObject.firstIndex"
            :nbResultsTotal="paginationObject.nbResultsTotal"
            :refreshEvent="paginationObject.refresh"
            :has-next="paginationObject.hasNext"
        >
        </cm-pagination-tracking-cacp>
      </b-col>
    </b-row>
<!--    <div aria-live="polite" aria-atomic="true" style="position: relative; min-height: 200px;">-->
<!--      <div id="toast-container" style="position: absolute; top: 0; right: 0;"></div>-->
<!--    </div>-->
  </div>
</template>

<script>
import conf from '../../config/config.dev.js'
import moment from 'moment-timezone'
//import moment from 'moment-timezone'
import Pagination from '@/components/common/pagination.vue'
import PaginationTrackingCACP from '@/components/common/paginationTrackingCACP.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import {downloadFileWithDefinedHeaders} from "@/helpers/download"
import BackButton from "@/components/common/backButton.vue"
import alpha2Country from "../../data/alpha2Country.json"
export default {
  name: 'TrackingList',
  components: {
    BackButton,
    'cm-pagination': Pagination,
    'cm-pagination-tracking-cacp': PaginationTrackingCACP,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    },
    filters: {
      type: Object,
      required: true
    },
    vopProviderList: {
      type: Array,
      default: () => []
    },
    displayFilter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fields () {
      let fields
      if (this.filters.tabName === 1) {
        if (this.flagCACP) {
          fields = [
            { key: 'MsgId', label: this.$i18n.t('tracking.message_id'), class: 'text-center', sortable: false },
            { key: 'FileSubmissionId', label: this.$i18n.t('tracking.flagCACP.file_submission_id'), class: 'text-center', sortable: false },
            { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), class: 'text-center', sortable: false },
            // { key: 'Request2CreationDate', label: this.$i18n.t('tracking.creation_date_request_2'), class: 'text-center', sortable: false },
            // { key: 'Response2CreationDate', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
            { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_1'), class: 'text-center', sortable: false },
            { key: 'ResponseDuration', label: this.$i18n.t('common.response_time'), class: 'text-center', sortable: false },
            { key: 'TechStatusCode', label: this.$i18n.t('tracking.flagCACP.demande_status'), class: 'text-center', sortable: false },
            { key: 'BICOnUs', label: this.$i18n.t('tracking.bic_onus'), class: 'text-center', sortable: false },
            { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
            { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
            // { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
            // { key: 'TestedData', label: this.$i18n.t('tracking.tested_data'), class: 'text-center', sortable: false },
            // { key: 'Result', label: this.$i18n.t('tracking.maching_result'), class: 'text-center', sortable: false },
            { key: 'ResultEntity', label: this.$i18n.t('tracking.flagCACP.check_result_entity'), class: 'text-center', sortable: false },
            { key: 'ReasonCodeAll', label: this.$i18n.t('tracking.flagCACP.reason_code'), class: 'text-center', sortable: false },
            // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: true },
            // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
            // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
            // { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: true },
          ]
        } else if (this.flagTOOLBOX) {
          fields = [
            // { key: 'Reference', label: this.$i18n.t('tracking.reference'), class: 'text-center', sortable: false },
            { key: 'CreationDateRq1', label: this.$i18n.t('common.dt'), class: 'text-center', sortable: false },
            { key: 'TestCaseName', label: this.$i18n.t('tracking.testcase_name'), class: 'text-center', sortable: false },
            { key: 'TestCaseStatus', label: this.$i18n.t('tracking.testcase_status'), class: 'text-center', sortable: false },
            { key: 'NameScore', label: this.$i18n.t('tracking.name_score'), class: 'text-center', sortable: false },
            { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code'), class: 'text-center', sortable: false },
          ]
        } else {
          fields = [
            { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), thClass: 'min-w-160px', class: 'text-center', sortable: false },
            { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
            { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
            { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
            { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
            { key: 'TestedData', label: this.$i18n.t('tracking.tested_data'), class: 'text-center', sortable: false },
            { key: 'Result', label: this.$i18n.t('tracking.maching_result'), class: 'text-center', sortable: false },
            { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code'), class: 'text-center', sortable: false },
            // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: true },
            // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
            // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
            // { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: true },
          ]
        }
      } else {
        if (this.flagCACP){
          fields = [
            { key: 'MsgId', label: this.$i18n.t('tracking.message_id_ddd'), class: 'text-center', sortable: false },
            { key: 'Provider', label: this.$i18n.t('tracking.provider_ddd'), class: 'text-center', sortable: false },
            // { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from_ddd'), class: 'text-center', sortable: false },
            { key: 'BICTo', label: this.$i18n.t('tracking.bic_to_ddd'), class: 'text-center', sortable: false },
            { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1_ddd'), class: 'text-center', sortable: false },
            // { key: 'Request2CreationDate', label: this.$i18n.t('tracking.creation_date_request_2_ddd'), class: 'text-center', sortable: false },
            // { key: 'Response2CreationDate', label: this.$i18n.t('tracking.creation_date_response_1_ddd'), class: 'text-center', sortable: false },
            { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2_ddd'), class: 'text-center', sortable: false },
            // { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
            // { key: 'Name', label: this.$i18n.t('tracking.name'), class: 'text-center', sortable: false },
            { key: 'ResponseDuration', label: this.$i18n.t('tracking.response_time_ddd'), class: 'text-center', sortable: false },
            { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code_ddd'), class: 'text-center', sortable: false },
            { key: 'Result', label: this.$i18n.t('tracking.result_ddd'), class: 'text-center', sortable: false },
            // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: false },
            // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
            // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
            // { key: 'Type', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: false },

          ]
        }
        else{
          fields = [
            { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), thClass: 'min-w-160px', class: 'text-center', sortable: false },
            { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
            { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
            { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
            { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
            { key: 'Name', label: this.$i18n.t('tracking.name'), class: 'text-center', sortable: false },
            { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code'), class: 'text-center', sortable: false },
            // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: false },
            // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
            // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
            { key: 'Type', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: false },
          ]
        }

      }

      return fields
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.filters.IBAN ||
          this.filters.BIC ||
          this.filters.BICFrom ||
          this.filters.BICTo ||
          this.filters.dateBegin ||
          this.filters.dateEnd ||
          this.filters.dateBeginRq2 ||
          this.filters.dateEndRq2 ||
          this.filters.dateBeginRp2 ||
          this.filters.dateEndRp2 ||
          this.filters.dateBeginRp1 ||
          this.filters.dateEndRp1 ||
          this.filters.TechStatusCode ||
          this.filters.CountryCode ||
          this.filters.MessageId ||
          this.filters.Result ||
          this.filters.ReasonCode ||
          this.filters.EntityRequestId ||
          this.filters.FileSubmissionId ||
          this.filters.ResultEntity ||
          this.filters.ReasonCodeEntity ||
          this.filters.TestCaseName ||
          this.filters.TestCaseStatus !== '') {
        return true
      }
      return false
    },
    tabName () {
      // Get tabName from filters
      return this.filters.tabName
    },
    resultMatchingOptions () {
      // Access from parent's data via $parent
      return this.$parent.resultMatchingOptions || [
        { id: "NOAP", text: "Not Applicable" },
        { id: "MTCH", text: "Match" },
        { id: "NMTC", text: "No Match" },
        { id: "CMTC", text: "Close Match" },
        { id: "NULL", text: this.$t('tracking.no_result') }
      ]
    },
  },
  data () {
    return {
      listEngineDown: [],
      isMandatoryFieldMiss: true,
      activateSpinner: false,
      filterBy: '',
      hasDefaultFilter: false,
      idTrackAcc: '',
      statusVerification: '',
      mode: 1,
      identifier: '',
      countries: alpha2Country.countries.reverse(),
      flagCACP: conf.visual === 'CACP',
      flagBPCE: conf.visual === 'BPCE',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      returnUrl: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      trackActive: '',
      TracksList: [],
      TracksListAll: [],
      lastDate: '',
      timezone: '+00:00'
    }
  },
  created () {
    this.timezone = moment.tz.guess()

    if (this.type === 'BULK') {
      this.defineReturnURL()
    }
    // this.$bus.$emit('switch-selected-menu', '/tracking/')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered-tracking'
    this.$bus.$off('direct-inbox-filtered-tracking')
    this.$bus.$on('direct-inbox-filtered-tracking', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    // Listen to parent events for refresh and export
    this.$bus.$off('refresh-tracking-list')
    this.$bus.$on('refresh-tracking-list', () => {
      this.applyFilter()
    })

    this.$bus.$off('export-tracking-list')
    this.$bus.$on('export-tracking-list', () => {
      if (this.canViewExtract()) {
        this.extractCSV()
      }
    })

    // Listen for filter apply event from parent
    this.$bus.$off('apply-filters-tracking')
    this.$bus.$on('apply-filters-tracking', (filters) => {
      // Filters are already updated via props, just apply them
      this.applyFilter()
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    if (!this.flagCACP){
      this.onRefresh(false)
    }
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.firstOn().tracking.cleanFilterCondition()
    // Clean up event listeners
    this.$bus.$off('refresh-tracking-list')
    this.$bus.$off('export-tracking-list')
    this.$bus.$off('direct-inbox-filtered-tracking')
    this.$bus.$off('apply-filters-tracking')
  },
  methods: {
    async fetchTracksAndMerge(filterConditions) {
      let that = this
      let requests = []
      let listEngineDownLocal = []


      for (let i = 0; i < this.$engine.engines.length; i++) {
        const engine = this.$engine.get(i)
        if (engine.common.network.state === 'offline') {
          continue
        }

        if (engine?.tracking?.getTracks) {
          try {
            const resp = await engine.tracking.getTracks(filterConditions)

              this.paginationObject.nbResultsTotal += resp.data.nbTotalTracks
              this.paginationObject.nbResults += resp.data.tracks.length

              // Ajoute engineIndex à chaque item
              const taggedTracks = resp.data.tracks.map(item => ({
                ...item,
                engineIndex: i
              }))
              requests.push(...taggedTracks)

          } catch (error) {
            if (error && error.code === 'ERR_NETWORK') {
              listEngineDownLocal.push({ index: i, host: engine?.common?.network?.info?.host || 'unknown', error })
            } else {
              errorMessageAlert(error, that)
            }
          }
        }
      }

      // Optional diagnostic state
      this.engineDown = null

      //Pas assez de donnée pour une nouvelle page
      if(this.paginationObject.maxResults > requests.length)
        this.paginationObject.hasNext = false;
      else
        this.paginationObject.hasNext = true;

      if (listEngineDownLocal.length === this.$engine.engines.length && listEngineDownLocal.length > 0) {
        errorMessageAlert(listEngineDownLocal[0].error, this)
      } else {

        const sortedRequests = requests.slice().sort((a, b) => {
          return new Date(b.CreationDateRq1) - new Date(a.CreationDateRq1);
        }).slice(0, this.paginationObject['maxResults'])


        if (this.flagCACP) {
          if (sortedRequests?.length){
            for (let i = sortedRequests.length - 1; i >= 0; i--) {
              const date = sortedRequests[i].CreationDateRq1;
              if (date) {
                this.lastDate = date
                break;
              }
            }
          }
        }

        this.updateInbox(sortedRequests)

        if (this.flagCACP) {
          this.TracksListAll[1] = sortedRequests
        }
        this.activateSpinner = false
      }
      this.listEngineDown = listEngineDownLocal
    },
    defineReturnURL () {
      let that = this
      this.returnUrl = '/trackingbulk/' + this.id
    },
    applyFilter (filterConditions = {}) {
      if (this.flagCACP) {
        this.TracksListAll = []
      }
      if (this.filters.dateBegin === '' && !this.flagTOOLBOX) {
        this.isMandatoryFieldMiss = true
        if (this.$f7 && this.$f7.alert) {
          this.$f7.alert('', this.$i18n.t('common.missing_required_field'))
        }
        return
      }
      this.isMandatoryFieldMiss = false
      this.TracksList = []
      let that = this
      this.filterTypeGet = 'list'

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.firstOn().tracking.cleanFilterCondition()

      // Use filters from props
      filterConditions.BIC = (this.filters.BIC || '').trim()
      filterConditions.BICFrom = (this.filters.BICFrom || '').trim()
      filterConditions.BICTo = (this.filters.BICTo || '').trim()
      filterConditions.IBAN = (this.filters.IBAN || '').trim()
      filterConditions.TechStatusCode = this.filters.TechStatusCode
      filterConditions.CountryCode = this.filters.CountryCode
      filterConditions.MessageId = this.filters.MessageId
      filterConditions.BICFromRegex = this.filters.BICFromRegex
      filterConditions.BICToRegex = this.filters.BICToRegex
      filterConditions.VopProvider = this.filters.VopProvider
      filterConditions.Result = this.filters.Result
      filterConditions.TestCaseName = this.filters.TestCaseName
      filterConditions.TestCaseStatus = this.filters.TestCaseStatus
      filterConditions.dateBegin = this.filters.dateBegin != '' ? moment(this.filters.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateEnd = this.filters.dateEnd != '' ? moment(this.filters.dateEnd , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateBeginRq2 = this.filters.dateBeginRq2 != '' ? moment(this.filters.dateBeginRq2 , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateEndRq2 = this.filters.dateEndRq2 != '' ? moment(this.filters.dateEndRq2 , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateBeginRp2 = this.filters.dateBeginRp2 != '' ? moment(this.filters.dateBeginRp2 , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateEndRp2 = this.filters.dateEndRp2 != '' ? moment(this.filters.dateEndRp2 , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateBeginRp1 = this.filters.dateBeginRp1 != '' ? moment(this.filters.dateBeginRp1 , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateEndRp1 = this.filters.dateEndRp1 != '' ? moment(this.filters.dateEndRp1 , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.BICFromOnus = this.filters.BICFromOnus != false ? '1' : ''
      filterConditions.BICToOnus = this.filters.BICToOnus != false ? '1' : ''
      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex
      filterConditions.Type = this.filters.tabName === 1 ? 'DDV' : 'DDD'
      if (this.flagCACP) {
        filterConditions.ReasonCode = this.filters.ReasonCode
        filterConditions.EntityRequestId = this.filters.EntityRequestId
        filterConditions.FileSubmissionId = this.filters.FileSubmissionId
        filterConditions.ResultEntity = this.filters.ResultEntity
        filterConditions.ReasonCodeEntity = this.filters.ReasonCodeEntity
      }
      let res = this.fetchTracksAndMerge(filterConditions)
    },
    canViewDetails () {
      return this.$engine.firstOn().rights.rightIs('tracks_consult_details', true)
    },
    canViewExtract () {
      return this.$engine.firstOn().rights.rightIs('tracks_consult_extract', true)
    },
    getCountry(countryCode) {

      if (!this.countries.includes(countryCode)) {
        return this.$t('countriesAlpha2Code.UNKNOWN')
      }

      return this.$t(`countriesAlpha2Code.${countryCode}`) || this.$t('countriesAlpha2Code.UNKNOWN')
    },
    getTestCaseStatus (status) {
      return this.$t('tracking.testcase_status_list.' + status) !== 'tracking.testcase_status_list.' ? this.$t('tracking.testcase_status_list.' + status) : '-'
    },
    getResultText (id) {
      const option = this.resultMatchingOptions.find(opt => opt.id === id)
      return option ? option.text : '-'
    },
    getResultDDD(item) {
      if ((item.ReasonCode == '') && (item.TechStatusCode == '')) {
        return this.$t('tracking.result.account_open')
      }


      if (item.TechStatusCode == 'STRM-CURL-28') {
        return this.$t('tracking.result.timeout')
      }

      if (item.TechStatusCode != '') {
        return this.$t('tracking.result.error')
      }

      switch (item.ReasonCode) {
        case '9201':
          return this.$t('tracking.result.account_close')
        case '9202':
          return this.$t('tracking.result.no_account')
        case '9203':
          return this.$t('tracking.result.other')
      }

    },
    handleRowClicked (item) {
      if (this.canViewDetails()) {
        this.seeTracksDetails(item)
      }
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.firstOn().settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.firstOn().settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    async onRefresh (noAttach = false, index = 1) {
      let that = this
      let requests = []
      let listEngineDownLocal = []

      if (this.TracksListAll[index] && this.flagCACP) {
        this.paginationObject['firstIndex'] = index
        this.TracksList = this.TracksListAll[index]
        return
      }

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index

      this.activateSpinner = true
      let filterConditions = {
        firstIndex: 1,
        maxResults: this.paginationObject.maxResults,
        Type: this.filters.tabName === 1 ? 'DDV' : 'DDD',
        BIC: (this.filters.BIC || '').trim(),
        BICFrom: (this.filters.BICFrom || '').trim(),
        BICTo: (this.filters.BICTo || '').trim(),
        IBAN: (this.filters.IBAN || '').trim(),
        TechStatusCode: this.filters.TechStatusCode,
        CountryCode: this.filters.CountryCode,
        MessageId: this.filters.MessageId,
        BICFromRegex: this.filters.BICFromRegex,
        BICToRegex: this.filters.BICToRegex,
        VopProvider: this.filters.VopProvider,
        Result: this.filters.Result,
        dateBegin: this.filters.dateBegin != '' ? moment(this.filters.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateEnd: this.filters.dateEnd != '' ? moment(this.filters.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateBeginRq2: this.filters.dateBeginRq2 != '' ? moment(this.filters.dateBeginRq2, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateEndRq2: this.filters.dateEndRq2 != '' ? moment(this.filters.dateEndRq2, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateBeginRp2: this.filters.dateBeginRp2 != '' ? moment(this.filters.dateBeginRp2, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateEndRp2: this.filters.dateEndRp2 != '' ? moment(this.filters.dateEndRp2, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateBeginRp1: this.filters.dateBeginRp1 != '' ? moment(this.filters.dateBeginRp1, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateEndRp1: this.filters.dateEndRp1 != '' ? moment(this.filters.dateEndRp1, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        BICFromOnus: this.filters.BICFromOnus != false ? '1' : '',
        BICToOnus: this.filters.BICToOnus != false ? '1' : ''
      }
      if (this.flagCACP) {
        if (index != 1){
          filterConditions.NoCount = 1
        }
        filterConditions = {
          ...filterConditions,
          ReasonCode: this.filters.ReasonCode,
          EntityRequestId: this.filters.EntityRequestId,
          FileSubmissionId: this.filters.FileSubmissionId,
          ResultEntity: this.filters.ResultEntity,
          ReasonCodeEntity: this.filters.ReasonCodeEntity
        }

        //filterConditions.dateBeginRq1 = that.lastDate != '' ? moment(that.lastDate , 'YYYY-MM-DD HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss'.SSSZ) : ''
        filterConditions.dateEnd = that.lastDate !== '' ? moment.utc(that.lastDate).tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''

      }
      else{

        filterConditions = {
          ...filterConditions,
          firstIndex: this.paginationObject.firstIndex
        }
      }
      // if (this.id !== 'NULL') {
      //   filterConditions.IdBulk = this.id
      // }

      for (let i = 0; i < this.$engine.engines.length; i++) {
        const engine = this.$engine.get(i)
        if (engine.common.network.state === 'offline') {
          continue
        }

        if (engine?.tracking?.getTracks) {
          try {
            const resp = await engine.tracking.getTracks(filterConditions)

            this.paginationObject.nbResults += resp.data.tracks.length

            // Ajoute engineIndex à chaque item
            const taggedTracks = resp.data.tracks.map(item => ({
              ...item,
              engineIndex: i
            }))
            requests.push(...taggedTracks)

          } catch (error) {
            if (error && error.code === 'ERR_NETWORK') {
              listEngineDownLocal.push({ index: i, host: engine?.common?.network?.info?.host || 'unknown', error })
            } else {
              errorMessageAlert(error, that)
            }
          }
        }
      }
      this.paginationObject.maxResults = 15
      //Pas assez de donnée pour une nouvelle page
      if(this.paginationObject.maxResults > requests.length){
        this.paginationObject.nbResultsTotal = this.paginationObject.firstIndex + requests.length
        this.paginationObject.hasNext = false;
      }
      else{
        this.paginationObject.hasNext = true;
      }

      this.engineDown = {
        host: 'server-prod-01',
        error: 'HTTP 500 – Internal Server Error'
      }

      if (listEngineDownLocal.length === this.$engine.length) {
        errorMessageAlert(listEngineDownLocal[0].error, this)
      } else {

        const sortedRequests = requests.slice().sort((a, b) => {
          return new Date(b.CreationDateRq1) - new Date(a.CreationDateRq1);
        }).slice(0, this.paginationObject['maxResults'])


        if (this.flagCACP) {
          if (sortedRequests?.length){
            for (let i = sortedRequests.length - 1; i >= 0; i--) {
              const date = sortedRequests[i].CreationDateRq1;
              if (date) {
                this.lastDate = date
                break;
              }
            }
          }
        }

        this.updateInbox(sortedRequests)

        if (this.flagCACP) {
          that.TracksListAll[index] = sortedRequests
        }
        this.activateSpinner = false
      }

    },
    extractCSV (){
      let that = this

      this.activateSpinner = true
      let filterConditions = {
        extract : 1,
        Type: this.tabName === 1 ? 'DDV' : 'DDD',
        BIC: (this.filters.BIC || '').trim(),
        BICFrom: (this.filters.BICFrom || '').trim(),
        BICTo: (this.filters.BICTo || '').trim(),
        IBAN: (this.filters.IBAN || '').trim(),
        TechStatusCode: this.filters.TechStatusCode,
        CountryCode: this.filters.CountryCode,
        MessageId: this.filters.MessageId,
        BICFromRegex: this.filters.BICFromRegex,
        BICToRegex: this.filters.BICToRegex,
        VopProvider: this.filters.VopProvider,
        Result: this.filters.Result,
        dateBegin: this.filters.dateBegin != '' ? moment(this.filters.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateEnd: this.filters.dateEnd != '' ? moment(this.filters.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateBeginRq2: this.filters.dateBeginRq2 != '' ? moment(this.filters.dateBeginRq2, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateEndRq2: this.filters.dateEndRq2 != '' ? moment(this.filters.dateEndRq2, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateBeginRp2: this.filters.dateBeginRp2 != '' ? moment(this.filters.dateBeginRp2, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateEndRp2: this.filters.dateEndRp2 != '' ? moment(this.filters.dateEndRp2, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateBeginRp1: this.filters.dateBeginRp1 != '' ? moment(this.filters.dateBeginRp1, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateEndRp1: this.filters.dateEndRp1 != '' ? moment(this.filters.dateEndRp1, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        BICFromOnus: this.filters.BICFromOnus != false ? '1' : '',
        BICToOnus: this.filters.BICToOnus != false ? '1' : ''
      }
      if (this.flagCACP) {
        filterConditions = {
          ...filterConditions,
          ReasonCode: this.filters.ReasonCode,
          EntityRequestId: this.filters.EntityRequestId,
          FileSubmissionId: this.filters.FileSubmissionId,
          ResultEntity: this.filters.ResultEntity,
          ReasonCodeEntity: this.filters.ReasonCodeEntity
        }
      }
      this.$engine.firstOn().tracking.getTracks(
        filterConditions
      ).then(resp => {
        that.$f7.hidePreloader()

        const binaryString = window.atob(resp.data)
        const len = binaryString.length
        const bytes = new Uint8Array(len)
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }

        const csvData = new TextDecoder('utf-8').decode(bytes)

        const rows = csvData.split('\n').map(row => row.split(';'))
        const headers = rows[0].map(header => header.replace(/\"/g, '').trim())
        const dataIndex = headers.indexOf('RequestStatus')

        const modifiedRows = rows.map((row, index) => {
          if (index === 0) return row
          if (row[dataIndex] && dataIndex !== -1) {
            row[dataIndex] = that.translateTechStatusCode(row[dataIndex])
          } else{
            row[dataIndex] = that.$t('common.monitoring.success')
          }
          return row
        })

        const modifiedCsv = "\ufeff" + modifiedRows.map(row => row.join(';')).join('\n')

        const linkSource = 'data:text/csv;charset=utf-8,' + encodeURIComponent(modifiedCsv)
        const downloadLink = document.createElement('a')
        let today = moment.tz()
        const fileName = this.$t('Webheader.tracking') + '_' + today.unix() + '.csv'

        if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }

        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
        that.activateSpinner = false
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (id, engineIndex = 0) {
      let that = this
      let type = that.tabName === 1 ? 'DDV':'DDD'
      if (this.type === 'BULK') {
        type = this.id
      }
      loadPage(that, {url: '/trackingdetails/' + type +'/' + id + '/' + engineIndex})
    },
    reOrderBy (column) {
      this.TracksList = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions

      // if (this.id !== 'NULL'){
      //   filterConditions.IdBulk = this.id
      // }
      this.$engine.firstOn().tracking.getTracks(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalTracks
        that.paginationObject.nbResults = resp.data.tracks.length
        resp.data.tracks.forEach(item => {
          item.statusVerification = item.statusVerification
          item.company_name = item.company_name
          item.active = item.active
        })
        requests = resp.data.tracks
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    translateTechStatusCode (code) {
      if (this.$t('tracking.error-status.' + code) !== 'tracking.error-status.' + code) {
        return this.$t('tracking.error-status.' + code)
      } else {
        return this.$t('tracking.error-status.default', { statusCode: code })
      }

    },
    updateInbox (requests, noAttach = false) {
      this.TracksList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeTracksDetails (items) {
      this.activateDetail(items.IdTrack, items.engineIndex)
    },
    getDate (date) {
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu’elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    getDuration (item) {
      if (item.CreationDateRq1 !== '' && item.Response2CreationDate !== '') {
        const start = moment(item.CreationDateRq1)
        const end = moment(item.Response2CreationDate)

        return end.diff(start, 'milliseconds') + ' ms'
      }
      else {
        return '-'
      }
    },
    changeTabName (tabValue) {
      // Emit the tab change to parent to update filters.tabName
      this.$emit('update-tab', tabValue)
      // Note: Filter application will be handled by the parent component
      // when the user explicitly applies filters, not automatically on tab change
    },
    showButtonImportLot () {
      return false
    }
  }
}
</script>

<style scoped>
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.result-mtch {
  background-color: rgba(0, 143, 57, 0.8);
}

.result-nmtc {
  background-color: rgba(204, 0, 0, 0.8);
}

.result-cmtc {
  background-color: rgba(230, 159, 0, 0.8);
}

.result-noap {
  background-color: rgba(153, 153, 153, 0.8);
}
</style>